import Vue from "vue";
import Router from "vue-router";

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const Index = () => import("views/oa/");
//首页
const Home = () => import("views/oa/home/");
const HomePage = () => import("views/oa/home/home-page/HomePage");
// 数据报表 -- 效率报表（index）
const EfficiencyReportIndex = () => import("views/oa/home/efficiency-report/");
// 数据报表 -- 效率报表
const EfficiencyReport = () => import("views/oa/home/efficiency-report/efficiency-report.vue");
const ProfitIndex = () => import("views/oa/home/profit/index.vue");
const ProfitList = () => import("views/oa/home/profit/profit-list/");
// 盈利报表 -- 科目明细
const ProfitAccountDetails = () => import("views/oa/home/profit/profit-list/account-details.vue");
// 盈利报表 -- 项目明细
const ProfitProjectdetails = () => import("views/oa/home/profit/profit-list/project-details.vue");
const CustomerSingleReport = () => import("views/oa/home/profit/CustomerSingleReport.vue");
const CustomerProductionDataIndex = () => import("views/oa/home/production-data/index.vue");
const CustomerShipmentData = () => import("views/oa/home/production-data/shipment-data/ShipmentData.vue");
const CustomerAfterSale = () => import("views/oa/home/production-data/after-sale/after-sale.vue");
const DataReportIndex = () => import("views/oa/home/data-report/index.vue");
const WarehouseDimension = () => import("views/oa/home/data-report/warehouse-dimension/warehouse-dimension.vue");
const CustomerDimension = () => import("views/oa/home/data-report/customer-dimension/customer-dimension.vue");


// 运营
const OperateIndex = () => import("views/oa/operate/");
// 运营 -- 应收款(index)
const FinanceIndex = () => import("views/oa/operate/finance/");
// 运营 -- 应收款 -- 客户账单(index)
const CustomerBill = () => import("views/oa/operate/finance/customer-bill/");
// 运营 -- 应收款 -- 客户账单 -- 日账单
const CustomerDateBill = () => import("views/oa/operate/finance/customer-bill/date-bill.vue");
// 运营 -- 应收款 -- 客户账单 -- 月账单
const CustomerMonthBill = () => import("views/oa/operate/finance/customer-bill/month-bill.vue");
// 运营 -- 应收款 -- 物流核验(index)
const NewLogisticsVerification = () => import("views/oa/operate/finance/logistics-verification-new/");
// // 运营 -- 应收款 -- 物流核验 -- 物流核验列表
const LogisticsVerificationList = () => import("views/oa/operate/finance/logistics-verification-new/logistics-verification-list.vue");
// // 运营 -- 应收款 -- 物流核验 -- 物流核验详情
const LogisticsVerificationDetails = () => import("views/oa/operate/finance/logistics-verification-new/logistics-verification-details.vue");
// 运营 -- 应收款 -- 物流核验(index)
const LogisticsVerification = () => import("views/oa/operate/finance/logistics-verification/");
// 运营 -- 应收款 -- 物流核验 -- 重量核验
const WeightVerification = () => import("views/oa/operate/finance/logistics-verification/weight-verification.vue");
// 运营 -- 应收款 -- 物流核验 -- 金额核验
const AmountVerification = () => import("views/oa/operate/finance/logistics-verification/amount-verification.vue");
// 运营 -- 应收款 -- 物流核验 -- 物流加收费
const LogisticsPlusCharges = () => import("views/oa/operate/finance/logistics-verification/logistics-plus-charges.vue");
// 运营 -- 应收款 -- 账单生成(index)
const BillGenerationIndex = () => import("views/oa/operate/finance/bill-generation/");
// 运营 -- 应收款 -- 账单生成(index)
const BillGeneration = () => import("views/oa/operate/finance/bill-generation/bill-generation.vue");
// 运营 -- 应付款(index)
const DuesIndex = () => import("views/oa/operate/dues/");
// 运营 -- 应付款 -- 人力资源账单(index)
const HrBill = () => import("views/oa/operate/dues/hr-bill/");
const HrDateBill = () => import("views/oa/operate/dues/hr-bill/hr-date-bill.vue");
const HrMonthBill = () => import("views/oa/operate/dues/hr-bill/hr-month-bill.vue");
// 运营 -- 应付款 -- 物流账单（index）
const LogisticsBill = () => import("views/oa/operate/dues/logistics-bill/");
// 运营 -- 应付款 -- 物流账单 -- 日账单
const LogisticsDateBill = () => import("views/oa/operate/dues/logistics-bill/date-bill.vue");
// 运营 -- 应付款 -- 物流账单 -- 月账单
const LogisticsMonthBill = () => import("views/oa/operate/dues/logistics-bill/month-bill.vue");
// 运营 -- 运营工作台(index)
const StagingIndex = () => import("views/oa/operate/staging/");
// 运营 -- 运营工作台
const Staging = () => import("views/oa/operate/staging/Staging.vue");


// 生产
const ProductionIndex = () => import("views/oa/production/");
// 生产 -- 库存作业（index）
const InventoryOperationIndex = () => import("views/oa/production/inventory-operation/");
// 生产 -- 库存作业 -- 实占面积录入
const RealArea = () => import("views/oa/production/inventory-operation/real-area.vue");
// 生产 -- 库存作业 -- 盘点
const Inventory = () => import("views/oa/production/inventory-operation/Inventory.vue");
// 生产 -- 人力资源（index）
const ResourceManageIndex = () => import("views/oa/production/resource-manage/");
// 生产 -- 人力资源 -- 人力成本
const LaborCost = () => import("views/oa/production/resource-manage/labor-cost.vue");
// 生产 -- 人力资源 -- 临时工支出
const TemporaryExpenditure = () => import("views/oa/production/resource-manage/temporary-expenditure.vue");
// 生产 -- 人力资源 -- 临时工签到
const TemporarySign = () => import("views/oa/production/resource-manage/temporary-sign.vue");
// 生产 -- 人力资源 -- 人力档案
const Archives = () => import("views/oa/production/resource-manage/Archives.vue");
// 生产 -- 退货作业（index）
const ReturnOperationIndex = () => import("views/oa/production/return-operation/");
// 生产 -- 退货作业 -- 退货登记
const ReturnRegister = () => import("views/oa/production/return-operation/return-register.vue");
// 生产 -- 退货作业 -- 退货报表
const ReturnList = () => import("views/oa/production/return-operation/return-list.vue");
// 生产 -- 退货作业 -- 退货处理
const ReturnProcessing = () => import("views/oa/production/return-operation/return-processing.vue");
// 生产 -- 收货作业（index）
const ReceivingIndex = () => import("views/oa/production/receiving/");
// 生产 -- 收货作业 -- 收货操作
const ReceivingOperation = () => import("views/oa/production/receiving/receipt-operation.vue");
// 生产 -- 收货作业 -- 收货列表
const ReceivingList = () => import("views/oa/production/receiving/receipt-list.vue");
// 生产 -- 增值服务（index）
const IncrementIndex = () => import("views/oa/production/increment/");
// 生产 -- 增值服务 -- 增值服务操作
const IncrementOperator = () => import("views/oa/production/increment/increment-operator.vue");
// 生产 -- 增值服务 -- 增值服务报表
const IncrementList = () => import("views/oa/production/increment/increment-list.vue");
// 生产 -- 大宗出库（index）
const BulkIndex = () => import("views/oa/production/bulk/");
// 生产 -- 大宗出库 -- 大宗出库操作
const BulkOperator = () => import("views/oa/production/bulk/bulk-operator.vue");
// 生产 -- 大宗出库 -- 大宗出库报表
const BulkList = () => import("views/oa/production/bulk/bulk-list.vue");
// 生产 -- 发货作业 -- 产线管理
const ProductionLineManagement = () => import("views/oa/production/bulk/production-line-management.vue");
// 生产 -- 发货作业 -- 班组管理（index）
const TeamIndex = () => import("views/oa/production/bulk/team/");
// 生产 -- 发货作业 -- 组长管理
const HeadmanManage = () => import("views/oa/production/bulk/team/headman-manage.vue");
// 生产 -- 发货作业 -- 班组详情
const TeamDetails = () => import("views/oa/production/bulk/team/team-details.vue");
// 生产 -- 发货作业 -- 生产查询
const ProduceSearch = () => import("views/oa/production/bulk/produce-search.vue");
// 生产 -- 发货作业 -- 订单取消
const OrderCancel = () => import("views/oa/production/bulk/order-cancel.vue");
// 生产 -- 发货作业 -- 物流补登
const LogisticsSupplementaryRegistration = () => import("views/oa/production/bulk/logistics-supplementary-registration.vue");
// 生产 -- 发货作业 -- 物流补登记录
const ManualOrderRecord = () => import("views/oa/production/bulk/manual-order-record.vue");
// 生产 -- 索赔（index）
const ClaimIndex = () => import("views/oa/production/claim/index");
// 生产 -- 索赔 -- 索赔登记
const ClaimRegister = () => import("views/oa/production/claim/claim-register");
// 生产 -- 索赔 -- 待确认表单
const ChargeTBCRecord = () => import("views/oa/production/claim/tbc-record.vue");
// 生产 -- 索赔 -- 已确认表单
const ChargeConfirmedRecord = () => import("views/oa/production/claim/confirmed-record.vue");
// 生产 -- 生产工作台（index）
const productionWorkbenchIndex = () => import("views/oa/production/production-workbench/");
// 生产 -- 生产工作台
const productionWorkbench = () => import("views/oa/production/production-workbench/production-workbench.vue");

//系统设置
const SystemSettingsIndex = () => import("views/oa/system-settings/");
//用户管理(index)
const UserManage = () => import("views/oa/system-settings/user-manage/");
const UserList = () => import("views/oa/system-settings/user-manage/UserManage");
const InvenstmentList = () => import("views/oa/system-settings/user-manage/InvenstmentManage");
//角色管理(index)
const RoleManageIndex = () => import("views/oa/system-settings/role-manage/");
const RoleManage = () => import("views/oa/system-settings/role-manage/RoleManage");
//基础资料(index)
const BaseDataIndex = () => import("views/oa/system-settings/base-data/");
//基础资料 -- 增值服务维护
const AddServiceMaintenance = () => import("views/oa/system-settings/base-data/add-service-maintenance/add-service-maintenance.vue");
//货主管理(index)
const CustomerManageIndex = () => import("views/oa/system-settings/customer-manage/");
//货主管理 -- 客户信息维护
const CustomerList = () => import("views/oa/system-settings/customer-manage/customer-list/CustomerList");
//货主管理 -- 项目信息维护(index)
const ProjectMangeIndex = () => import("views/oa/system-settings/customer-manage/project-list/");
//货主管理 -- 项目信息维护列表
const ProjectMange = () => import("views/oa/system-settings/customer-manage/project-list/ProjectManage.vue");
//货主管理 -- 新增项目
const AddProject = () => import("views/oa/system-settings/customer-manage/project-list/AddProject.vue");
//货主管理 -- 编辑项目
const ModProject = () => import("views/oa/system-settings/customer-manage/project-list/ModProject.vue");
//货主管理 -- 项目详情
const ProjectDetails = () => import("views/oa/system-settings/customer-manage/project-list/ProjectDetails.vue");
//货主管理 -- 商品信息维护
const GoodsInfoList = () => import("views/oa/system-settings/customer-manage/goods-info/GoodsInfo.vue");
//仓库管理(index)
const WarehouseManageIndex = () => import("views/oa/system-settings/warehouse-manage/");
const WarehouseBaseInfo = () => import("views/oa/system-settings/warehouse-manage/warehouse-base-info/warehouse-base-info.vue");
const WarehouseLocation = () => import("views/oa/system-settings/warehouse-manage/warehouse-location/warehouse-location.vue");
const DepartmentInfo = () => import("views/oa/system-settings/warehouse-manage/department-info/department-info.vue");
//系统设置 -- 供应商管理(index)
const SupplierManageIndex = () => import("views/oa/system-settings/supplier-manage/");
//系统设置 -- 供应商管理 -- 人力资源
const SupplierManageHumanResources = () => import("views/oa/system-settings/supplier-manage/human-resources/human-resources.vue");
//系统设置 -- 供应商管理 -- 物流资源（index）
const SupplierManageLogisticsIndex = () => import("views/oa/system-settings/supplier-manage/logistics-resources/");
//系统设置 -- 供应商管理 -- 物流资源列表
const SupplierManageLogisticsList = () => import("views/oa/system-settings/supplier-manage/logistics-resources/logistics-list.vue");
//系统设置 -- 供应商管理 -- 快递规则
const SupplierManageExpressRules = () => import("views/oa/system-settings/supplier-manage/logistics-resources/express-rules.vue");
// 系统设置 -- 成本信息(index)
const CostInfoIndex = () => import("views/oa/system-settings/cost-info/index.vue");
// 系统设置 -- 成本信息
const CostInfo = () => import("views/oa/system-settings/cost-info/cost-info.vue");

const Login = () => import("views/oa/login/Login");

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      component: Index,
      redirect: "/home",
      children: [
        {
          path: "/home",
          name: "home",
          component: Home,
          redirect: "/home/home-page",
          meta: {
            menuName: "数据报表",
            authKeyWord: 'DATA_REPORT'
          },
          children: [
            {
              path: "home-page",
              name: "home-page",
              component: HomePage,
            },
            {
              path: "data-report",
              name: "data-report",
              component: DataReportIndex,
              redirect: "/home/data-report/warehouseDimension",
              meta: {
                menuName: "数据总表",
                authKeyWord: 'DATA_REPORT_data_summary'
              },
              children: [
                {
                  path: "warehouseDimension",
                  name: "warehouseDimension",
                  component: WarehouseDimension,
                  meta: {
                    menuChildName: "仓库维度",
                    menuName: "数据总表",
                    keepAlive: true,
                    authKeyWord: 'DATA_REPORT_data_summary'
                  },
                },
                {
                  path: "customerDimension",
                  name: "customerDimension",
                  component: CustomerDimension,
                  meta: {
                    menuChildName: "客户维度",
                    menuName: "数据总表",
                    keepAlive: true,
                    authKeyWord: 'DATA_REPORT_data_summary'
                  },
                }
              ]
            },
            {
              path: "profitIndex",
              name: "profitIndex",
              component: ProfitIndex,
              redirect: "/home/profitIndex/profit",
              meta: {
                menuName: "盈利报表",
                authKeyWord: 'DATA_REPORT_profit_statement'
              },
              children: [
                {
                  path: "profit",
                  name: "profit",
                  component: ProfitList,
                  redirect: "/home/profitIndex/profit/account-details",
                  meta: {
                    menuName: "盈利报表",
                    keepAlive: true,
                    authKeyWord: 'DATA_REPORT_profit_statement'
                  },
                  children: [
                    {
                      path: "account-details",
                      name: "account-details",
                      component: ProfitAccountDetails,
                      meta: {
                        menuChildName: "科目明细",
                        menuName: "盈利报表",
                        keepAlive: true,
                        authKeyWord: 'DATA_REPORT_profit_statement'
                      },
                    },
                    {
                      path: "project-details",
                      name: "project-details",
                      component: ProfitProjectdetails,
                      meta: {
                        menuChildName: "项目明细",
                        menuName: "盈利报表",
                        keepAlive: true,
                        authKeyWord: 'DATA_REPORT_profit_statement'
                      }
                    }
                  ]
                },
                {
                  path: "customerSingleReport",
                  name: "customerSingleReport",
                  component: CustomerSingleReport,
                  meta: {
                    menuName: "盈利明细详情",
                    authKeyWord: 'DATA_REPORT_profit_statement'
                  },
                },
              ]
            },
            {
              path: "production-data",
              name: "production-data",
              component: CustomerProductionDataIndex,
              redirect: "/home/production-data/shipment-data",
              meta: {
                authKeyWord: 'DATA_REPORT_quality_report'
              },
              children: [
                {
                  path: "shipment-data",
                  name: "shipment-data",
                  component: CustomerShipmentData,
                  meta: {
                    menuChildName: "发货数据",
                    menuName: "质量报表",
                    keepAlive: true,
                    authKeyWord: 'DATA_REPORT_quality_report'
                  },
                },
                {
                  path: "after-sale",
                  name: "after-sale",
                  component: CustomerAfterSale,
                  meta: {
                    menuChildName: "揽收数据",
                    menuName: "质量报表",
                    keepAlive: true,
                    authKeyWord: 'DATA_REPORT_quality_report'
                  }
                }
              ]
            },
            {
              path: "efficiency-report-index",
              name: "efficiency-report-index",
              component: EfficiencyReportIndex,
              redirect: "/home/efficiency-report-index/efficiency-report",
              meta: {
                authKeyWord: 'DATA_REPORT_efficiency_report'
              },
              children: [
                {
                  path: "efficiency-report",
                  name: "efficiency-report",
                  component: EfficiencyReport,
                  meta: {
                    menuName: "效率报表",
                    authKeyWord: 'DATA_REPORT_efficiency_report'
                  },
                },
              ]
            },
          ]
        },
        {
          path: "/operate",
          name: "/operate",
          component: OperateIndex,
          redirect: "/operate/finance",
          meta: {
            menuName: "运营管理",
            authKeyWord: 'OPERATION'
          },
          children: [
            {
              path: "finance",
              name: "finance",
              component: FinanceIndex,
              redirect: "/operate/finance/customerBill",
              meta: {
                menuName: "应收款管理",
                authKeyWord: 'OPERATION_financial'
              },
              children: [
                {
                  path: "customerBill",
                  name: "customerBill",
                  component: CustomerBill,
                  redirect: "/operate/finance/customerBill/customerDateBill",
                  meta: {
                    authKeyWord: 'OPERATION_financial_receivables_management'
                  },
                  children: [
                    {
                      path: "customerDateBill",
                      name: "customerDateBill",
                      component: CustomerDateBill,
                      meta: {
                        menuChildName: "日账单",
                        menuName: "客户账单",
                        keepAlive: true,
                        authKeyWord: 'OPERATION_financial_receivables_management'
                      },
                    },
                    {
                      path: "customerMonthBill",
                      name: "customerMonthBill",
                      component: CustomerMonthBill,
                      meta: {
                        menuChildName: "月账单",
                        menuName: "客户账单",
                        keepAlive: true,
                        authKeyWord: 'OPERATION_financial_receivables_management'
                      },
                    },
                  ]
                },
                {
                  path: "newLogisticsVerification",
                  name: "newLogisticsVerification",
                  component: NewLogisticsVerification,
                  redirect: "/operate/finance/newLogisticsVerification/logisticsVerificationList",
                  meta: {
                    authKeyWord: 'OPERATION_financial_receivables_management_logistics_check_new'
                  },
                  children: [
                    {
                      path: "logisticsVerificationList",
                      name: "logisticsVerificationList",
                      component: LogisticsVerificationList,
                      meta: {
                        menuName: "物流核验（新）",
                        authKeyWord: 'OPERATION_financial_receivables_management_logistics_check_new'
                      },
                    },
                    {
                      path: "logisticsVerificationDetails/:name",
                      name: "logisticsVerificationDetails/:name",
                      component: LogisticsVerificationDetails,
                      meta: {
                        authKeyWord: 'OPERATION_financial_receivables_management_logistics_check_new'
                      }
                    },
                  ]
                },
                {
                  path: "logisticsVerification",
                  name: "logisticsVerification",
                  component: LogisticsVerification,
                  redirect: "/operate/finance/logisticsVerification/weightVerification",
                  meta: {
                    authKeyWord: 'OPERATION_financial_receivables_management_logistics_check'
                  },
                  children: [
                    {
                      path: "weightVerification",
                      name: "weightVerification",
                      component: WeightVerification,
                      meta: {
                        menuChildName: "重量账单",
                        menuName: "物流核验",
                        keepAlive: true,
                        authKeyWord: 'OPERATION_financial_receivables_management_logistics_check'
                      },
                    },
                    {
                      path: "amountVerification",
                      name: "amountVerification",
                      component: AmountVerification,
                      meta: {
                        menuChildName: "金额核验",
                        menuName: "物流核验",
                        keepAlive: true,
                        authKeyWord: 'OPERATION_financial_receivables_management_logistics_check'
                      },
                    },
                    {
                      path: "logisticsPlusCharges",
                      name: "logisticsPlusCharges",
                      component: LogisticsPlusCharges,
                      meta: {
                        menuChildName: "物流加收费",
                        menuName: "物流核验",
                        keepAlive: true,
                        authKeyWord: 'OPERATION_financial_receivables_management_logistics_check'
                      },
                    }
                  ]
                },
                {
                  path: "billGenerationIndex",
                  name: "billGenerationIndex",
                  component: BillGenerationIndex,
                  redirect: "/operate/finance/billGenerationIndex/billGeneration",
                  meta: {
                    authKeyWord: 'OPERATION_financial_receivables_management_bill_generate'
                  },
                  children: [
                    {
                      path: "billGeneration",
                      name: "billGeneration",
                      component: BillGeneration,
                      meta: {
                        menuName: "账单生成",
                        authKeyWord: 'OPERATION_financial_receivables_management_bill_generate'
                      },
                    }
                  ]
                }
              ]
            },
            {
              path: "dues",
              name: "dues",
              component: DuesIndex,
              redirect: "/operate/dues/hrBill",
              meta: {
                menuName: "应付款管理",
                authKeyWord: 'OPERATION_financial_payables_management'
              },
              children: [
                {
                  path: "hrBill",
                  name: "hrBill",
                  component: HrBill,
                  redirect: "/operate/dues/hrBill/hrDateBill",
                  meta: {
                    authKeyWord: 'OPERATION_financial_payables_management_hr_bill'
                  },
                  children: [
                    {
                      path: "hrDateBill",
                      name: "hrDateBill",
                      component: HrDateBill,
                      meta: {
                        menuChildName: "日账单",
                        menuName: "人力账单",
                        keepAlive: true,
                        authKeyWord: 'OPERATION_financial_payables_management_hr_bill'
                      },
                    },
                    {
                      path: "hrMonthBill",
                      name: "hrMonthBill",
                      component: HrMonthBill,
                      meta: {
                        menuChildName: "月账单",
                        menuName: "人力账单",
                        keepAlive: true,
                        authKeyWord: 'OPERATION_financial_payables_management_hr_bill'
                      },
                    },
                  ]
                },
                {
                  path: "logisticsBill",
                  name: "logisticsBill",
                  component: LogisticsBill,
                  redirect: "/operate/dues/logisticsBill/logisticsDateBill",
                  meta: {
                    authKeyWord: 'OPERATION_financial_payables_management_lr_bill'
                  },
                  children: [
                    {
                      path: "logisticsDateBill",
                      name: "logisticsDateBill",
                      component: LogisticsDateBill,
                      meta: {
                        menuChildName: "日账单",
                        menuName: "物流账单",
                        keepAlive: true,
                        authKeyWord: 'OPERATION_financial_payables_management_lr_bill'
                      },
                    },
                    {
                      path: "logisticsMonthBill",
                      name: "logisticsMonthBill",
                      component: LogisticsMonthBill,
                      meta: {
                        menuChildName: "月账单",
                        menuName: "物流账单",
                        keepAlive: true,
                        authKeyWord: 'OPERATION_financial_payables_management_lr_bill'
                      },
                    },
                  ]
                },
              ]
            },
            {
              path: "stagingIndex",
              name: "stagingIndex",
              component: StagingIndex,
              redirect: "/operate/stagingIndex/staging",
              meta: {
                authKeyWord: 'OPERATION_workbench'
              },
              children: [
                {
                  path: "staging",
                  name: "staging",
                  component: Staging,
                  meta: {
                    menuName: "运营工作台",
                    authKeyWord: 'OPERATION_workbench'
                  },
                },
              ]
            }
          ]
        },
        {
          path: "/production",
          name: "/production",
          component: ProductionIndex,
          redirect: "/production/inventory-operation",
          meta: {
            menuName: "生产管理",
            authKeyWord: 'PRODUCTION'
          },
          children: [
            {
              path: "inventory-operation",
              name: "inventory-operation",
              component: InventoryOperationIndex,
              redirect: "/production/inventory-operation/real-area",
              meta: {
                menuName: "库存作业",
                authKeyWord: 'PRODUCTION_inventory_job'
              },
              children: [
                {
                  path: "real-area",
                  name: "real-area",
                  component: RealArea,
                  meta: {
                    menuName: "实占面积录入",
                    authKeyWord: 'PRODUCTION_inventory_job_real_occupied_area_input'
                  },
                },
                {
                  path: "inventory",
                  name: "inventory",
                  component: Inventory,
                  meta: {
                    menuName: "盘点",
                    authKeyWord: 'PRODUCTION_inventory_job_check'
                  }
                },
              ]
            },
            {
              path: "resource-manage",
              name: "resource-manage",
              component: ResourceManageIndex,
              redirect: "/production/resource-manage/labor-cost",
              meta: {
                menuName: "人力资源",
                authKeyWord: 'PRODUCTION_resource_management'
              },
              children: [
                {
                  path: "labor-cost",
                  name: "labor-cost",
                  component: LaborCost,
                  meta: {
                    menuName: "人力成本",
                    authKeyWord: 'PRODUCTION_resource_management_the_human_cost'
                  },
                },
                {
                  path: "temporary-expenditure",
                  name: "temporary-expenditure",
                  component: TemporaryExpenditure,
                  meta: {
                    menuName: "临时工支出",
                    authKeyWord: 'PRODUCTION_hr_tmp_spending'
                  },
                },
                {
                  path: "temporary-sign",
                  name: "temporary-sign",
                  component: TemporarySign,
                  meta: {
                    menuName: "临时工打卡",
                    authKeyWord: 'PRODUCTION_hr_tmp_clock_in'
                  },
                },
                {
                  path: "archives",
                  name: "archives",
                  component: Archives,
                  meta: {
                    menuName: "人力档案",
                    authKeyWord: 'PRODUCTION_resource_management_hr_files'
                  },
                },
              ]
            },
            {
              path: "return-operation",
              name: "return-operation",
              component: ReturnOperationIndex,
              redirect: "/production/return-operation/return-register",
              meta: {
                menuName: "退货作业",
                authKeyWord: 'PRODUCTION_return_of_the_homework'
              },
              children: [
                {
                  path: "return-register",
                  name: "return-register",
                  component: ReturnRegister,
                  meta: {
                    menuName: "退货登记",
                    authKeyWord: 'PRODUCTION_return_of_the_homework_return_of_the_registration'
                  },
                },
                {
                  path: "return-list",
                  name: "return-list",
                  component: ReturnList,
                  meta: {
                    menuName: "退货记录",
                    authKeyWord: 'PRODUCTION_return_of_the_homework_any_returns_return_report'
                  },
                },
                {
                  path: "return-processing",
                  name: "return-processing",
                  component: ReturnProcessing,
                  meta: {
                    menuName: "退货处理",
                    authKeyWord: 'PRODUCTION_return_of_the_homework_any_returns'
                  },
                },
              ]
            },
            {
              path: "receiving",
              name: "receiving",
              component: ReceivingIndex,
              redirect: "/production/receiving/receiving-operation",
              meta: {
                menuName: "收货作业",
                authKeyWord: 'PRODUCTION_receive_job'
              },
              children: [
                {
                  path: "receiving-operation",
                  name: "receiving-operation",
                  component: ReceivingOperation,
                  meta: {
                    menuName: "收货登记",
                    authKeyWord: 'PRODUCTION_receive_job_receiving_operation'
                  },
                },
                {
                  path: "receiving-list",
                  name: "receiving-list",
                  component: ReceivingList,
                  meta: {
                    menuName: "收货记录",
                    authKeyWord: 'PRODUCTION_receive_job_receipt_data_report'
                  },
                }
              ]
            },
            {
              path: "increment",
              name: "increment",
              component: IncrementIndex,
              redirect: "/production/increment/increment-operation",
              meta: {
                menuName: "增值服务",
                authKeyWord: 'PRODUCTION_value_added_services'
              },
              children: [
                {
                  path: "increment-operation",
                  name: "increment-operation",
                  component: IncrementOperator,
                  meta: {
                    menuName: "增值服务登记",
                    authKeyWord: 'PRODUCTION_value_added_services_operation'
                  },
                },
                {
                  path: "increment-list",
                  name: "increment-list",
                  component: IncrementList,
                  meta: {
                    menuName: "增值服务记录",
                    authKeyWord: 'PRODUCTION_value_added_services_report'
                  },
                }
              ]
            },
            {
              path: "bulk",
              name: "bulk",
              component: BulkIndex,
              redirect: "/production/bulk/bulk-operation",
              meta: {
                menuName: "发货作业",
                authKeyWord: 'PRODUCTION_delivery_job'
              },
              children: [
                {
                  path: "bulk-operation",
                  name: "bulk-operation",
                  component: BulkOperator,
                  meta: {
                    menuName: "大宗出库登记",
                    authKeyWord: 'PRODUCTION_delivery_job_operation'
                  },
                },
                {
                  path: "bulk-list",
                  name: "bulk-list",
                  component: BulkList,
                  meta: {
                    menuName: "大宗出库记录",
                    authKeyWord: 'PRODUCTION_delivery_job_report'
                  },
                },
                {
                  path: "produce-search",
                  name: "produce-search",
                  component: ProduceSearch,
                  meta: {
                    menuName: "订单查询",
                    authKeyWord: 'PRODUCTION_delivery_order_query'
                  },
                },
                {
                  path: "production-line",
                  name: "production-line",
                  component: ProductionLineManagement,
                  meta: {
                    menuName: "产线管理",
                    authKeyWord: 'PRODUCTION_delivery_job_production_line_manager'
                  },
                },
                {
                  path: "order-cancel",
                  name: "order-cancel",
                  component: OrderCancel,
                  meta: {
                    menuName: "订单取消记录",
                    authKeyWord: 'PRODUCTION_delivery_order_cancel'
                  },
                },
                {
                  path: "team",
                  name: "team",
                  component: TeamIndex,
                  redirect: "/production/bulk/team/team-details",
                  meta: {
                    menuName: "班组管理",
                    authKeyWord: 'PRODUCTION_delivery_job_team_manager'
                  },
                  children: [
                    {
                      path: "team-details",
                      name: "team-details",
                      component: TeamDetails,
                      meta: {
                        menuChildName: "班组详情",
                        menuName: "班组管理",
                        keepAlive: true,
                        authKeyWord: 'PRODUCTION_delivery_job_team_manager'
                      },
                    },
                    {
                      path: "headman-manage",
                      name: "headman-manage",
                      component: HeadmanManage,
                      meta: {
                        menuChildName: "组长管理",
                        menuName: "班组管理",
                        keepAlive: true,
                        authKeyWord: 'PRODUCTION_delivery_job_team_manager'
                      }
                    }
                  ]
                },

                {
                  path: "logistics-supplementary-registration",
                  name: "logistics-supplementary-registration",
                  component: LogisticsSupplementaryRegistration,
                  meta: {
                    menuName: "物流补登",
                    authKeyWord: 'PRODUCTION_logisti_manual_order_register'
                  },
                },
                {
                  path: "manual-order-record",
                  name: "manual-order-record",
                  component: ManualOrderRecord,
                  meta: {
                    menuName: "物流补登记录",
                    authKeyWord: 'PRODUCTION_logisti_manual_order_query'
                  },
                }
              ]
            },
            {
              path: "claim-index",
              name: "claim-index",
              component: ClaimIndex,
              redirect: "/production/claim-index/claim-register",
              meta: {
                menuName: "索赔",
                authKeyWord: 'PRODUCTION_claim'
              },
              children: [
                {
                  path: "claim-register",
                  name: "claim-register",
                  component: ClaimRegister,
                  meta: {
                    menuName: "索赔登记",
                    authKeyWord: 'PRODUCTION_claim_check'
                  }
                },
                {
                  path: "tbc-record",
                  name: "tbc-record",
                  component: ChargeTBCRecord,
                  meta: {
                    menuName: "待确认表单",
                    authKeyWord: 'PRODUCTION_claim_no_check_form'
                  }
                },
                {
                  path: "confirmed-record",
                  name: "confirmed-record",
                  component: ChargeConfirmedRecord,
                  meta: {
                    menuName: "已确认表单",
                    authKeyWord: 'PRODUCTION_claim_is_check_form'
                  }
                },
              ]
            },
            {
              path: "production-workbench-index",
              name: "production-workbench-index",
              component: productionWorkbenchIndex,
              redirect: "/production/production-workbench-index/production-workbench",
              children: [
                {
                  path: "production-workbench",
                  name: "production-workbench",
                  component: productionWorkbench,
                  meta: {
                    menuName: "生产工作台",
                    authKeyWord: 'PRODUCTION_workbench'
                  }
                },
              ]
            }
          ]
        },
        {
          path: "/system-settings",
          name: "/system-settings",
          component: SystemSettingsIndex,
          redirect: "/system-settings/user-manage",
          meta: {
            menuName: "系统设置",
            authKeyWord: 'SETTING'
          },
          children: [
            {
              path: "user-manage",
              name: "user-manage",
              component: UserManage,
              redirect: "/system-settings/user-manage/user-list",
              meta: {
                authKeyWord: 'SETTING_user'
              },
              children: [
                {
                  path: "user-list",
                  name: "user-list",
                  component: UserList,
                  meta: {
                    menuName: "用户管理",
                    menuChildName: "用户管理",
                    keepAlive: true,
                    authKeyWord: 'SETTING_user'
                  }
                },
                {
                  path: "invenstment-list",
                  name: "invenstment-list",
                  component: InvenstmentList,
                  meta: {
                    menuName: "用户管理",
                    menuChildName: "投资人管理",
                    keepAlive: true,
                    authKeyWord: 'SETTING_user'
                  }
                }
              ]
            },
            {
              path: "role-manage-index",
              name: "role-manage-index",
              component: RoleManageIndex,
              redirect: "/system-settings/role-manage-index/role-manage",
              meta: {
                authKeyWord: 'SETTING_biz_role'
              },
              children: [
                {
                  path: "role-manage",
                  name: "role-manage",
                  component: RoleManage,
                  meta: {
                    menuName: "角色管理",
                    authKeyWord: 'SETTING_biz_role'
                  },
                }
              ]
            },
            {
              path: "baseDataIndex",
              name: "baseDataIndex",
              component: BaseDataIndex,
              redirect: "/system-settings/baseDataIndex/addServiceMaintenance",
              meta: {
                authKeyWord: 'SETTING_base_info'
              },
              children: [
                {
                  path: "addServiceMaintenance",
                  name: "addServiceMaintenance",
                  component: AddServiceMaintenance,
                  meta: {
                    menuName: "增值服务维护",
                    authKeyWord: 'SETTING_base_info_extra_service'
                  },
                }
              ]
            },
            {
              path: "customer-manage-index",
              name: "customer-manage-index",
              component: CustomerManageIndex,
              redirect: "/system-settings/customer-manage-index/customer-list",
              meta: {
                authKeyWord: 'SETTING_customer'
              },
              children: [
                {
                  path: "customer-list",
                  name: "customer-list",
                  component: CustomerList,
                  meta: {
                    menuName: "客户信息",
                    authKeyWord: 'SETTING_customer_information'
                  },
                },
                {
                  path: "project-manage-index",
                  name: "project-manage-index",
                  component: ProjectMangeIndex,
                  redirect: "/system-settings/customer-manage-index/project-manage-index/project-manage", 
                  meta: {
                    authKeyWord: 'SETTING_customer_project'
                  },
                  children: [
                    {
                      path: "project-manage",
                      name: "project-manage",
                      component: ProjectMange,
                      meta: {
                        menuName: "项目信息",
                        authKeyWord: 'SETTING_customer_project'
                      },
                    },
                    {
                      path: "add-project",
                      name: "add-project",
                      component: AddProject,
                      meta: {
                        menuName: "新增项目",
                        authKeyWord: 'SETTING_customer_project'
                      },
                    },
                    {
                      path: "mod-project/:name",
                      name: "mod-project/:name",
                      component: ModProject,
                      meta: {
                        authKeyWord: 'SETTING_customer_project'
                      },
                    },
                    {
                      path: "project-details/:name",
                      name: "project-details/:name",
                      component: ProjectDetails,
                      meta: {
                        authKeyWord: 'SETTING_customer_project'
                      },
                    },
                  ]
                },
                {
                  path: "goods-info",
                  name: "goods-info",
                  component: GoodsInfoList,
                  meta: {
                    menuName: "商品信息",
                    authKeyWord: 'SETTING_customer_goods'
                  },
                }
              ]
            },
            {
              path: "warehouse-manage-index",
              name: "warehouse-manage-index",
              component: WarehouseManageIndex,
              redirect: "/system-settings/warehouse-manage-index/base-info",
              meta: {
                authKeyWord: 'SETTING_warehouse'
              },
              children: [
                {
                  path: "base-info",
                  name: "base-info",
                  component: WarehouseBaseInfo,
                  meta: {
                    menuName: "仓库基础信息",
                    authKeyWord: 'SETTING_warehouse_information'
                  },
                },
                {
                  path: "warehouse-location",
                  name: "warehouse-location",
                  component: WarehouseLocation,
                  meta: {
                    menuName: "仓库库位",
                    authKeyWord: 'SETTING_warehouse_location'
                  },
                },
                {
                  path: "department-info",
                  name: "department-info",
                  component: DepartmentInfo,
                  meta: {
                    menuName: "部门信息",
                    authKeyWord: 'SETTING_warehouse_information_dept_info'
                  },
                },
              ]
            },
            {
              path: "supplier-manage-index",
              name: "supplier-manage-index",
              component: SupplierManageIndex,
              redirect: "/system-settings/supplier-manage-index/supplier-human-resources",
              meta: {
                menuName: "供应商管理",
                authKeyWord: 'SETTING_supplier_manager'
              },
              children: [
                {
                  path: "supplier-human-resources",
                  name: "supplier-human-resources",
                  component: SupplierManageHumanResources,
                  meta: {
                    menuName: "人力资料",
                    authKeyWord: 'SETTING_supplier_manager_hr'
                  },
                },
                {
                  path: "supplier-logistics-index",
                  name: "supplier-logistics-index",
                  component: SupplierManageLogisticsIndex,
                  redirect: "/system-settings/supplier-manage-index/supplier-logistics-index/supplier-logistics-list",
                  meta: {
                    authKeyWord: 'SETTING_supplier_manager_lr'
                  },
                  children: [
                    {
                      path: "supplier-logistics-list",
                      name: "supplier-logistics-list",
                      component: SupplierManageLogisticsList,
                      meta: {
                        menuName: "物流资源",
                        authKeyWord: 'SETTING_supplier_manager_lr'
                      },
                    },
                    {
                      path: "supplier-express-rules/:name",
                      name: "supplier-express-rules/:name",
                      component: SupplierManageExpressRules,
                      meta: {
                        authKeyWord: 'SETTING_supplier_manager_lr'
                      },
                    },
                  ]
                }
              ]
            },
            {
              path: "cost-info-index",
              name: "cost-info-index",
              component: CostInfoIndex,
              redirect: "/system-settings/cost-info-index/cost-info",
              children: [
                {
                  path: "cost-info",
                  name: "cost-info",
                  component: CostInfo,
                  meta: {
                    menuName: "成本信息",
                    authKeyWord: 'SETTING_other_cost'
                  },
                }
              ]
            },
          ]
        },
      ]
    },
    {
      path: "/login",
      component: Login
    }
  ]
});

router.afterEach((to) => {
  if (to.name === 'project-details/:name' || to.name === 'mod-project/:name' || to.name === 'supplier-express-rules/:name' || to.name === 'logisticsVerificationDetails/:name') {
    to.meta.menuName = to.params.name
  }
});

export default router;
